<template>
    <div>
        <Breadcrumbs title="Rules Setting" />
        <div class="container-fluid">
            <div class="d-flex justify-content-end">
                <b-button class="border-0 p-0 mr-0 mb-2" style="background: #287cfb" v-b-modal.addRule>
                    <div class="d-flex justify-content-center align-items-center add-btn w-100 h-100 px-3 py-1"
                        style="border-radius: 0.3em; background: #287cfb">
                        <i class="icofont icofont-plus-circle mr-2"></i>
                        <span style="font-size: 1em; color: #fff"> Create New Rule</span>
                    </div>
                </b-button>
            </div>
            <addRule :data="{
                queueOri: queueOri,
                queue: queue,
            }" :editRuleData="editRuleData" @clearEdit='editRuleData = null' @addNewRule="addNewRule"
                @editRule="putRule" />
            <div class="card p-4">
                <!-- <div style="height: 3.1em" class="d-flex justify-content-end mb-2">
                     <div class="mr-2 d-flex">
                        <div class='searchIcon'>
                            <feather style="width: 15px; " type="search" />
                        </div>
                        <b-form-input style="width: 15em !important; padding: 0 0em 0 2em; height: 100%" type="text"
                            placeholder="Search" v-model="search" @input="searchData" />

                    </div>

                </div> -->
                <div>
                    <dataTableVue ref="refDataTable" :isShowSelect="false" :isSearch3="true" :isSearch="false"
                        :isExport="false" :isPagination='false' :isFilter="false" :renderMode="'csr'" @load="loadItems"
                        v-bind:data="{
                columns: columns,
                rows: rows,
                rowCustom: 'rowRuleSetting',
                msg: '*** กรณีอีเมล์ไม่เข้าเงื่อนไขใดเลย ระบบจะส่งงานไปยัง queue SCG&NON ***'
            }" @deleteRow="deleteRule" @editRow="editRule" @moveRow="moveRow" @editToggle="editToggle" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { requestService } from '../../_services/request.service';
import addRule from '@/components/rules-setting/add-new-rule.vue';
export default {
    components: {
        addRule,
    },
    data() {
        return {
            queueOri: [],
            queue: [],
            search: '',
            editRuleData: null,
            columns: [
                {
                    label: 'Rule Name',
                    field: 'rule_name',
                    sortable: false,
                    hidden: false,
                },
                {
                    label: 'Rule Details',
                    field: 'rule_detail',
                    sortable: false,
                    hidden: false,
                },
                {
                    label: 'Status',
                    field: 'status',
                    sortable: false,
                    hidden: false,
                    width: '10%',
                },
                {
                    label: 'Action',
                    field: 'actions',
                    width: '15%',
                    sortable: false,
                    hidden: false,
                },
            ],
            rows: [

            ],
            rows2: [

            ],
        };
    },

    mounted() {
        this.getQueue();
        this.loadItems();
    },

    methods: {
        searchData(input) {
            // console.log('search: ', input);

            if (input == '') {
                this.rows = this.rows2;
            } else {
                this.rows = this.rows2;
                this.rows = this.rows.filter((row) =>
                    row.name.toLowerCase().includes(input.toLowerCase())
                );
            }
        },
        getQueue() {
            let url = `/api/mail/queue_management`;
            requestService.GetFetch('ccp', url).then((res) => {
                if (res.status == 200) {
                    res.text().then((text) => {
                        const data = text && JSON.parse(text);
                        this.queueOri = data.data.filter((e) => e.status === true);
                        this.queueOri.forEach((e) => {
                            this.queue.push(e.name);
                        });
                    });
                }
            });
        },
        loadItems(e) {
            // console.log('load: ', e)
            if (e != undefined) {
                this.searchData(e.search);
            } else {
                let url = `/api/mail/rules_management`;
                requestService.GetFetch('ccp', url).then((res) => {
                    if (res.status == 200) {
                        res.text().then((text) => {
                            const data = text && JSON.parse(text);
                            this.rows = data.data;
                            let index = 1;
                            let maxObject = null;
                            let maxValue = -Infinity;
                            let row2 = this.rows;
                            row2 = row2.filter((row) => {
                                return row._id !== '65fd2bc2004c9c0defa38468';
                            });

                            if (this.rows.length > 0) {
                                for (const obj of row2) {
                                    if (obj.index > maxValue) {
                                        maxValue = obj.index;
                                        maxObject = obj;
                                    }
                                }
                            }
                            this.rows = this.rows.map((e2) => {
                                // console.log('maxObject: ', e2, maxObject.index)
                                if (e2.index == maxObject.index) {
                                    let obj = {
                                        ...e2,
                                        isLast: true
                                    }
                                    return obj
                                } else {
                                    let obj = {
                                        ...e2,
                                        isLast: false
                                    }
                                    return obj
                                }
                            })
                        });
                    }
                });
            }
        },
        async moveRow(e) {
            // console.log('e: ', e)
            let selected = e.index;
            let notSelected = null;
            if (e.type == 'up') {
                if (e.originalIndex > 0) {
                    notSelected = e.originalIndex - 1;
                    // notSelected = e.index - 1;
                }
            } else if (e.type == 'down') {
                if (e.originalIndex < this.rows.length - 1) {
                    notSelected = e.originalIndex + 1;
                    // notSelected = e.index + 1;
                }
            }

            let selectData = this.rows.filter((e1) => {
                return e1.index == e.index
            });
            // let selectData = this.rows[e.index];
            let selectDataIndex = selectData[0].index;
            // let selectDataIndex = this.rows[e.index].index;

            // let notSelectData = this.rows.filter((e2) => {
            //     return e2.index == notSelected
            // });
            let notSelectData = this.rows[notSelected];
            let notSelectDataIndex = notSelectData.index;
            // let notSelectDataIndex = this.rows[notSelected].index;

            selectData[0].index = notSelectDataIndex;
            notSelectData.index = selectDataIndex;
            // console.log('selectData: ', selectData)
            // console.log('notSelectData: ', notSelectData)

            let url = `/api/mail/rules_management/${selectData[0]._id}`;
            requestService
                .PutFetch('ccp', url, selectData[0])
                .then((res) => {
                    let url2 = `/api/mail/rules_management/${notSelectData._id}`;
                    requestService
                        .PutFetch('ccp', url2, notSelectData)
                        .then((res) => {
                            this.loadItems();
                            // if (res.status == 200) {
                            // }
                        })
                        .catch((err) => {
                            this.$swal.fire({
                                icon: 'error',
                                title: 'Something went wrong.',
                                text: err,
                            });
                        });

                })
                .catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Something went wrong.',
                        text: err,
                    });
                });



            // }
        },
        editToggle(e) {
            this.putRule(e);
        },
        addNewRule(payload) {
            let index = 1;
            let maxObject = {};
            let maxValue = -Infinity;

            let row2 = this.rows == null ? [] : this.rows;
            // console.log('row2: ', row2)
            if (row2.length != 0) {

                row2 = row2.filter((row) => {
                    return row.index != 9999;
                    // return row._id !== '65fd2bc2004c9c0defa38468' || row.index != 9999;
                });
            }

            // console.log('row2: ', row2, row2.length)
            if (row2.length == 0) {
                maxObject.index = 0
            }
            else if (row2.length > 0) {
                for (const obj of row2) {
                    if (obj.index > maxValue) {
                        maxValue = obj.index;
                        maxObject = obj;
                    }
                }
            }
            // console.log('maxObject: ', maxObject);
            payload.index = maxObject.index + 1;
            // console.log('payload: ', payload)
            let url = `/api/mail/rules_management`;
            requestService
                .PostFetch('ccp', url, payload)
                .then((res) => {
                    if (res.status == 200) {
                        this.loadItems();
                    }
                })
                .catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Something went wrong.',
                        text: err,
                    });
                });
        },
        editRule(e) {
            this.editRuleData = e;
        },
        putRule(item) {
            // console.log('item: ', item)
            let payload = {
                rule_name: item.rule_name,
                rule_detail: item.rule_detail,
                condition: item.condition,
                route_to: item.route_to,
                status: item.status,
                index: item.index,
            };
            // console.log('paylaod: ', payload);
            let url = `/api/mail/rules_management/${item._id}`;
            requestService
                .PutFetch('ccp', url, payload)
                .then((res) => {
                    if (res.status == 200) {
                        this.loadItems();
                    }
                })
                .catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Something went wrong.',
                        text: err,
                    });
                });
        },
        deleteRule(e) {
            // console.log('delete: ', e);
            let url = `/api/mail/rules_management/${e._id}`;
            this.$swal
                .fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2971FF',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        requestService
                            .DeleteFetch('ccp', url)
                            .then(() => {
                                this.$swal.fire(
                                    'Deleted!',
                                    'Your rule has been deleted.',
                                    'success'
                                );
                                this.loadItems();
                            })
                            .catch((err) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'Something went wrong.',
                                    text: err,
                                });
                            });
                    }
                });
        },
    },
};
</script>

<style scoped>
.searchIcon {
    position: relative;
    top: 0.7em;
    left: 2.5em;
}

.container-fluid {
    font-size: 10px;
}
</style>
